import LoginPage from "./login.json";
import ForgotPasswordDialog from "./forgot_password.json";
import layout from "./layout.json";
import ResetPassword from "./reset_password.json";
import SuccessDialog from "./success_dialog.json";
import ValidationForm from "./validation_form.json";
import dashboard from "./dashboard.json";
import help from "./help.json";
import reviewManagement from "./review_management.json";
import register from "./register.json";
import booking from "./booking.json";
import chipContent from "./chip_content.json";
import button from "./button.json";
import packagePage from "./package.json";
import voucher from "./voucher.json";
import billing from "./billing.json";
import accountManagement from "./account_management.json";
import menu from "./menu.json";
import ranking from "./ranking.json";
import analyticsPerformance from "./analytics_performance.json";
import allotments from "./allotments.json";
import documents from "./documents.json";
import marketing from "./marketing.json";
import exportPage from "./export_page.json";
import filterPage from "./filter_page.json";
import toast from "./toast.json";
import exportHistory from "./export_history.json";
import selectBranch from "./select_branch.json";
import multiBranch from "./multi_branch.json";
import report from "./report.json";
import pricingRules from "./pricing_rules.json";
import error from "./error.json";
import setPassword from "./set_password.json";

export default {
  title: "Portal Rakan Kongsi",
  login: LoginPage,
  forgotPassword: ForgotPasswordDialog,
  layout,
  resetPassword: ResetPassword,
  successDialog: SuccessDialog,
  validationForm: ValidationForm,
  dashboard: dashboard,
  help: help,
  register: register,
  reviewManagement: reviewManagement,
  booking: booking,
  chipContent: chipContent,
  button: button,
  package: packagePage,
  voucher: voucher,
  billing: billing,
  ranking: ranking,
  accountManagement: accountManagement,
  menu: menu,
  analyticsPerformance: analyticsPerformance,
  allotments: allotments,
  documents: documents,
  marketing: marketing,
  exportPage: exportPage,
  filterPage: filterPage,
  toast: toast,
  exportHistory: exportHistory,
  selectBranch: selectBranch,
  multiBranch: multiBranch,
  report: report,
  pricingRules: pricingRules,
  error: error,
  setPassword,
};
